<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="dash">
    <form class="" [formGroup]="mappings">
      <div class="input-fileds-container">
        <div class="row">
          <div class="col-md-12">
            <mat-label>Truck No</mat-label>
            <mat-form-field appearance="fill" class="example-full-width">
              <input
                matInput
                [formControl]="truckControl"
                [matAutocomplete]="trucks"
                required
              />
              <mat-autocomplete
                #trucks="matAutocomplete"
                (optionSelected)="selectTruck($event.option.value)"
              >
                <mat-option
                  *ngFor="let option of filteredTrucks | async"
                  [value]="option"
                >
                  {{ option.truck_number }}
                </mat-option>
              </mat-autocomplete>
              <mat-error>Please select the any one truck.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-label>Driver Name</mat-label>
            <mat-form-field appearance="fill" class="example-full-width">
              <input
                matInput
                [formControl]="driverControl"
                [matAutocomplete]="drivers"
                required
              />
              <mat-autocomplete
                #drivers="matAutocomplete"
                (optionSelected)="selectDriver($event.option.value)"
              >
                <mat-option
                  *ngFor="let option of filteredDriver | async"
                  [value]="option"
                >
                  {{ option.username }}
                </mat-option>
              </mat-autocomplete>
              <mat-error>Please select the any one driver.</mat-error>
            </mat-form-field>
          </div>
        </div>
        <button
          class="md-raised button buttonBlue fixed-btn"
          (click)="addMappings()"
        >
          Assign
        </button>
        <div class="mapping-bottom">
          <div class="search">
            <input
              toUppercase
              appAlphanumericOnly
              class="search pl-2"
              placeholder="Truck Number"
              id="searchTruckNumber"
              #newItem
            />
            <img
              (click)="search(newItem.value)"
              *ngIf="search_btn"
              src="assets/img/search.svg"
              alt=""
            />
            <a class="truck-header-search-icon" *ngIf="clear_btn">
              <img
                (click)="resetSearch()"
                src="../../../assets/img/cross_icon.svg"
              />
            </a>
          </div>
          
          <div class="to_container">
            <div [class.spinner]="loading"></div>

            <div
              class="row"
              *ngIf="!mappingList?.length && !loading"
            >
              <h4 class="error_msg">No Records Found.</h4>
            </div>
            <table *ngIf="mappingList?.length && !loading">
              <thead>
                <tr>
                  <th>Truck No</th>
                  <th>Name</th>
                  <th>Mobile Number</th>
                  <th>Mapping Date</th>
                </tr>
              </thead>
              <tbody *ngFor="let mapping of mappingList; let i = index">
                <tr>
                  <td>{{ mapping.truckInfo[0]?.truck_number }}</td>
                  <td>{{ mapping.driverInfo[0]?.username }}</td>
                  <td>{{ mapping.driverInfo[0]?.mobile }}</td>
                  <td>{{ mapping.createdAt | date : "dd-MM-yyyy" }}</td>
                  <td>
                    <button (click)="deleteMapping(mapping)" type="button">
                      <img src="../../../assets/img/delete-black.svg" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('-1')"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1">
        <img
          src="../../../assets/img/pagination-left.svg"
          (click)="pagination('first')"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page">
        <img
          src="../../../assets/img/pagination-right.svg"
          (click)="pagination('last')"
          alt=""
          class="btn--icon"
        />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('1')"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
